module.exports = __webpack_public_path__ + "img/socketio.288caf89.png";